import { z } from 'zod';

export const PROMOTION_REVISIONED_LINE_ITEM_TYPES = Object.freeze({
  Fixed: 'FixedPromotion',
  Percentage: 'PercentagePromotion',
});

export const PromotionRevisionedLineItemTypeSchema = z.nativeEnum(PROMOTION_REVISIONED_LINE_ITEM_TYPES).openapi('PromotionRevisionedLineItemType');
export type PromotionRevisionedLineItemType = z.infer<typeof PromotionRevisionedLineItemTypeSchema>;

export const basePromotionRevisionedLineItemFormSchema = z.object({
  name: z.string().nonempty(),
  description: z.string().optional(),
  type: PromotionRevisionedLineItemTypeSchema,
});

const FixedPromotionSchema = basePromotionRevisionedLineItemFormSchema.extend({
  type: z.literal(PROMOTION_REVISIONED_LINE_ITEM_TYPES.Fixed),
  price: z.number().min(1),
});
export type FixedRevisionedLineItemForm = z.infer<typeof FixedPromotionSchema>;

const PercentagePromotionSchema = basePromotionRevisionedLineItemFormSchema.extend({
  type: z.literal(PROMOTION_REVISIONED_LINE_ITEM_TYPES.Percentage),
  percentage: z.number().max(100).min(1),
});
export type PercentageRevisionedLineItemForm = z.infer<typeof PercentagePromotionSchema>;

export const PromotionRevisionedLineItemFormSchema = z.union([
  FixedPromotionSchema,
  PercentagePromotionSchema,
]);

export type PromotionRevisionedLineItemForm = z.infer<typeof PromotionRevisionedLineItemFormSchema>;